export default __webpack_public_path__ + "static/media/aboutSection3.8f0352f4.png";